import { SOMS_SECRET } from "components/common/CONSTANTS";

const AESGCM = {
  ALGORITHM: "AES-GCM",
  HASH: "SHA-256",
  KEY_SIZE: 256,
  ITERATION_COUNT: 100000,
};

const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();

export const decryption = async (encryptedValue) => {
  const [ciphertextStr, ivStr, saltStr] = encryptedValue.split(":");
  const ciphertext = Uint8Array.from(atob(ciphertextStr), c => c.charCodeAt(0));
  const iv = Uint8Array.from(atob(ivStr), c => c.charCodeAt(0));
  const salt = Uint8Array.from(atob(saltStr), c => c.charCodeAt(0));

  const algorithm = AESGCM.ALGORITHM;
  const keyMaterial = await generateKeyMaterial(SOMS_SECRET);
  const key = await generateKey(keyMaterial, salt);

  const decryptedData = await crypto.subtle.decrypt(
    {
      name: algorithm,
      iv,
    },
    key,
    ciphertext
  );

  return textDecoder.decode(decryptedData);
};

export const encryptRequest = async (request) => {
  const res = JSON.stringify(request);
  const encryptedRequest = await encryptData(res, SOMS_SECRET);
  return encryptedRequest;
};

export const encryptString = async (data) => {
  const encryptedRequest = await encryptData(data, SOMS_SECRET);
  return encryptedRequest;
};

const generateKeyMaterial = (password) => {
  return crypto.subtle.importKey(
    "raw",
    textEncoder.encode(password),
    { name: "PBKDF2" },
    false,
    ["deriveBits", "deriveKey"]
  );
};

const generateKey = (keyMaterial, salt) => {
  const algorithm = AESGCM.ALGORITHM;
  const hash = AESGCM.HASH;
  const iterationCount = AESGCM.ITERATION_COUNT;
  const keySize = AESGCM.KEY_SIZE;

  return crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt,
      iterations: iterationCount,
      hash: hash,
    },
    keyMaterial,
    {
      name: algorithm,
      length: keySize,
    },
    true,
    ["encrypt", "decrypt"]
  );
};

const encryptData = async (plaintext, password) => {
  const data = textEncoder.encode(plaintext);
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const keyMaterial = await generateKeyMaterial(password);
  const key = await generateKey(keyMaterial, salt);
  const algorithm = AESGCM.ALGORITHM;
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encryptedData = await crypto.subtle.encrypt(
    {
      name: algorithm,
      iv,
    },
    key,
    data
  );
  const ciphertextBase64 = btoa(
    String.fromCharCode.apply(null, new Uint8Array(encryptedData))
  );
  const ivBase64 = btoa(String.fromCharCode.apply(null, iv));
  const saltBase64 = btoa(String.fromCharCode.apply(null, salt));

  return ciphertextBase64 + ":" + ivBase64 + ":" + saltBase64;
};
